package br.com.htms.inspeccaocampo.data

enum class FormTipo(val id: String, val rotulo: String, val rotuloCurto: String) {
    INSPECAO_CAMPO(
        id = "INSPECAO_CAMPO",
        rotulo = "Inspeção de Campo Diária",
        rotuloCurto = "Inspeção"
    ),
    RELATORIO_FOTO_ALOJAMENTO(
        id = "RELATORIO_FOTO_ALOJAMENTO",
        rotulo = "Relatório Fotográfico-Alojamento",
        rotuloCurto = "Rel. Foto"
    ),
    CHECKLIST_ALOJAMENTO(
        id = "CHECKLIST_ALOJAMENTO",
        rotulo = "Checklist - Alojamento",
        rotuloCurto = "Checklist"
    ),
    RELATORIO_ALOJAMENTO(
        id = "RELATORIO_ALOJAMENTO",
        rotulo = "Relatório Alojamento",
        rotuloCurto = "Rel. Aloj."
    ),
    COMUNICACAO_OCORRENCIAS(
        id = "COMUNICACAO_OCORRENCIAS",
        rotulo = "Comunicação de ocorrências",
        rotuloCurto = "Ocorrências"
    );

    companion object {
        fun fromId(raw: String?): FormTipo =
            entries.find { it.id.equals(raw, ignoreCase = true) } ?: INSPECAO_CAMPO
    }
}

/** C / NC / NA — mesma lógica ternária; checklist usa C/NC/NA, relatório foto usa Sim/Não/N/A. */
enum class RespostaConformidade(val codigo: String, val rotulo: String) {
    C("C", "Conforme"),
    NC("NC", "Não conforme"),
    NA("NA", "Não se aplica");

    /** Rótulo Sim / Não / N/A (Relatório Fotográfico). */
    val rotuloSimNao: String
        get() = when (this) {
            C -> "Sim"
            NC -> "Não"
            NA -> "N/A"
        }

    companion object {
        const val LEGENDA = "C - CONFORME    NC - NÃO CONFORME    NA - NÃO APLICÁVEL"
        const val LEGENDA_SIM_NAO = "Sim / Não / N/A"

        fun fromName(raw: String?): RespostaConformidade? =
            raw?.takeIf { it.isNotBlank() }?.let { runCatching { valueOf(it) }.getOrNull() }
    }
}

enum class TipoCampoExtra {
    NENHUM,
    NUMERO,
    TEXTO
}

data class ItemConformidade(
    val id: String,
    val numero: String,
    val titulo: String,
    val secao: String,
    val resposta: RespostaConformidade? = null,
    val fotos: List<FotoAnexo> = emptyList(),
    val justificativa: String = "",
    val valorExtra: String = "",
    val tipoExtra: TipoCampoExtra = TipoCampoExtra.NENHUM,
    val labelExtra: String = "",
    val fotoHabilitada: Boolean = true,
    val fotoObrigatoria: Boolean = true,
    val obrigatorio: Boolean = true
) {
    val tituloNumerado: String
        get() = if (numero.isBlank()) titulo else "$numero $titulo"
}

data class SecaoConformidade(
    val titulo: String,
    val itens: List<ItemConformidade>
)
